import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { login } from "./routeRecords/login";
import { StarterCallback } from "@/starter";
const routes: Array<RouteRecordRaw> = [login];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
export const initRouter: StarterCallback = (app) => {
  app.config.globalProperties.$router = router;
  app.use(router);
};
router.beforeEach(async (to, _from, next) => {
  if (!to.name) {
    next({ name: "login" });
    return;
  }

  next();
});
export default router;
